import { CustomPricingSort } from "@classes-service-types/custom-pricing-sort.ts";
import { SortOrder } from "@classes-service-types/sort-order.ts";
import { ref } from "vue";

const DEFAULT_FIELD = CustomPricingSort.CreatedAt;
const DEFAULT_ORDER = SortOrder.Desc;

const field = ref<CustomPricingSort>(DEFAULT_FIELD);
const order = ref<SortOrder>(DEFAULT_ORDER);

export const useSortFilters = () => ({
  field,
  order,
  updateField: (v: CustomPricingSort): void => {
    field.value = v;
  },
  updateOrder: (v: SortOrder): void => {
    order.value = v;
  },
  resetSort: (): void => {
    field.value = DEFAULT_FIELD;
    order.value = DEFAULT_ORDER;
  },
});
